import { TRESPONSE_FETCH_LIBRARY_METHODS, TRESPONSE_FETCH_LIBRARY_OBS } from '@monorepo/types';

export type TLibraryState = {
  methodsListingInfo: null | TRESPONSE_FETCH_LIBRARY_METHODS;
  obListingInfo: null | TRESPONSE_FETCH_LIBRARY_OBS;
};

export const LibraryActionType = {
  FetchAllMethods: 'FETCH_ALL_METHODS' as const,
  FetchAllMethodsSuccess: 'FETCH_ALL_METHODS_SUCCESS' as const,
  FetchAllMethodsFailure: 'FETCH_ALL_METHODS_FAILURE' as const,

  FetchAllOBs: 'FETCH_ALL_OBS' as const,
  FetchAllOBsSuccess: 'FETCH_ALL_OBS_SUCCESS' as const,
  FetchAllOBsFailure: 'FETCH_ALL_OBS_FAILURE' as const,
};
